import apiClient from './config';
import { API_ENDPOINTS } from '../config/api';

// Obtener una historia clínica por ID
export const getHistoriaClinica = (id) => apiClient.get(API_ENDPOINTS.MEDICAL_RECORD.DETAIL(id));

// Buscar historia clínica por cédula del paciente
export const getHistoriaClinicaPorCedula = (cedula) => apiClient.get(API_ENDPOINTS.MEDICAL_RECORD.LIST_BY_CEDULA(cedula));

// Obtener todas las historias clínicas
export const getHistoriasClinicas = (params) => apiClient.get(API_ENDPOINTS.MEDICAL_RECORD.LIST, { params });

// Crear una nueva historia clínica
export const createHistoriaClinica = (data) => apiClient.post(API_ENDPOINTS.MEDICAL_RECORD.CREATE, data);

// Actualizar una historia clínica existente
export const updateHistoriaClinica = (id, data) => apiClient.put(API_ENDPOINTS.MEDICAL_RECORD.UPDATE(id), data);

// Agregar un diagnóstico a una historia clínica
export const agregarDiagnostico = (historiaId, data) => apiClient.post(API_ENDPOINTS.MEDICAL_RECORD.ADD_DIAGNOSIS(historiaId), data);

// Crear una receta médica para un diagnóstico
export const crearReceta = (historiaId, diagnosticoId, data) => {
  console.log('crearReceta - Datos a enviar:', {
    url: API_ENDPOINTS.MEDICAL_RECORD.CREATE_RECIPE(historiaId, diagnosticoId),
    data: data
  });
  
  return apiClient.post(API_ENDPOINTS.MEDICAL_RECORD.CREATE_RECIPE(historiaId, diagnosticoId), data);
};

// Obtener valores para campos específicos de una historia clínica
export const getValoresCampo = (historiaId) => {
  // En lugar de una ruta específica para valores, usamos la ruta general
  // que ya incluye todos los valores en la respuesta
  return apiClient.get(API_ENDPOINTS.MEDICAL_RECORD.DETAIL(historiaId));
};

// Actualizar valores de campos en una historia clínica
export const actualizarValoresCampo = (historiaId, data) => {
  console.log('Enviando datos para actualizar:', historiaId, data);
  return apiClient.put(API_ENDPOINTS.MEDICAL_RECORD.UPDATE(historiaId), data);
};

// Cargar archivo/imagen para un campo específico
export const cargarArchivoCampo = async (historiaId, campoId, archivo) => {
  try {
    console.log(`Subiendo archivo para historia ${historiaId}, campo ${campoId}`);
    const formData = new FormData();
    formData.append('archivo', archivo);
    
    const response = await apiClient.post(
      `${API_ENDPOINTS.MEDICAL_RECORD.DETAIL(historiaId)}/campos/${campoId}/archivo`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    );
    
    console.log('Respuesta de subida de archivo:', response.data);
    return response;
  } catch (error) {
    console.error('Error al cargar archivo:', error);
    throw error;
  }
};

// Descargar historia clínica en PDF
export const descargarHistoriaPDF = async (historiaId) => {
  try {
    // Esta llamada usa responseType blob para recibir un binario
    const response = await apiClient.get(`${API_ENDPOINTS.MEDICAL_RECORD.DETAIL(historiaId)}/pdf`, {
      responseType: 'blob'
    });
    
    return response;
  } catch (error) {
    console.error('Error al descargar PDF de historia clínica:', error);
    throw error;
  }
};